import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { useAuthStore } from "@wlink/commons/auth";
import { useFavicon } from "@wlink/commons/config";
import { createWlinkI18n } from "@wlink/commons/i18n";
import ElementPlus from "element-plus";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// 先导入Element Plus的CSS
import "@shared/styles/global.css";
import "element-plus/dist/index.css";

// 最后导入UI组件库 - 这样自定义样式可以覆盖Element Plus默认样式
import "@wlink/components/ui/src";

// 初始化应用
async function initApp() {
  const app = createApp(App);

  // 创建国际化实例
  const i18n = createWlinkI18n();

  // 注册Element Plus图标
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }

  const pinia = createPinia();
  app.use(pinia);
  app.use(router);
  app.use(ElementPlus);
  app.use(i18n);
  // 尽早初始化认证状态，避免路由守卫等待
  try {
    const authStore = useAuthStore();
    authStore.initAuth();

    // 如果用户已登录，初始化租户列表
    if (authStore.isAuthenticated) {
      const { useTenantStore } = await import("@support/stores/tenant");
      const tenantStore = useTenantStore();
      // 在后台静默加载，不阻塞应用启动
      tenantStore.fetchTenantList().catch((error) => {
        console.warn("租户列表初始化失败:", error);
      });
    }
  } catch (error) {
    console.warn("初始化失败:", error);
  }

  // 已移除 Sentry

  try {
    // await initAppGlobalConfig();

    // 初始化favicon（如果有配置的话）
    useFavicon();
  } catch (error) {
    console.warn("全局配置初始化失败，使用默认配置:", error);
  }

  app.mount("#app");
}

// 启动应用
initApp().catch(console.error);
